var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExaminationsActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 7,
    fill: "#4B9BF5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3261 13.2197L23.8002 8.74563L23.0546 8L18.5805 12.4741L17.8348 11.7284L13.3118 16.2514L15.5488 18.4885L20.0718 13.9654L19.3261 13.2197Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0748 16.9971L11.8204 17.7427L9.58337 19.9798L11.8204 22.2168L14.0574 19.9798L14.8031 20.7254L15.5487 19.9798L11.8204 16.2515L11.0748 16.9971Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.144 16.4745H24.4166V17.529H19.144V16.4745Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1439 18.6182H24.4166V26H19.1439V18.6182Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExaminationsActive);
export default __webpack_public_path__ + "static/media/ExaminationsActive.6be97a30cf2c54cd6e110916bb00aeda.svg";
export { ForwardRef as ReactComponent };